<template>
<div class="chapter">
<div class="inner_page">
<div id="toc" style="font-weight:bold">
<h1 id="toc-title">The Gentlemen’s Club</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-1-marcia-jones">Chapter 1: Marcia Jones</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-2-barnaby-brown">Chapter 2: Barnaby Brown</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-3-detective-inspector-james-jones">Chapter 3: Detective
                Inspector James Jones</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-4-jean-wellington">Chapter 4: Jean Wellington</a></li>
<li id="toc-li-8"><a href="#/text/ch008#chapter-5-cynthia">Chapter 5: Cynthia</a></li>
<li id="toc-li-9"><a href="#/text/ch009#chapter-6-barney-and-jimmy">Chapter 6: Barney and Jimmy</a></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-7-aunt-jean-and-natalie" title="Link target outside of Sample">Chapter 7: Aunt Jean and
                Natalie</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-8-detective-inspector-james-jones" title="Link target outside of Sample">Chapter 8: Detective
                Inspector James Jones</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-9-police-commissioner-bennet" title="Link target outside of Sample">Chapter 9: Police Commissioner
                Bennet</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-10-detective-maureen-sullivan" title="Link target outside of Sample">Chapter 10: Detective Maureen
                Sullivan</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-11-detective-inspector-james-jones" title="Link target outside of Sample">Chapter 11: Detective
                Inspector James Jones</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-12-troy-trent-and-tyrone-bennet" title="Link target outside of Sample">Chapter 12: Troy, Trent,
                and Tyrone Bennet</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-13-shirley-bennet" title="Link target outside of Sample">Chapter 13: Shirley Bennet</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-14-the-bennet-boys" title="Link target outside of Sample">Chapter 14: The Bennet Boys</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-15-barnaby-and-di-james-jones" title="Link target outside of Sample">Chapter 15: Barnaby and DI
                James Jones</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-16-maureen-and-barnaby" title="Link target outside of Sample">Chapter 16: Maureen and Barnaby</span>
</li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-17-tina-bennet" title="Link target outside of Sample">Chapter 17: Tina Bennet</span></li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-18-jean-and-miriam" title="Link target outside of Sample">Chapter 18: Jean and Miriam</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-19-maureen-and-barnaby" title="Link target outside of Sample">Chapter 19: Maureen and Barnaby</span>
</li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-20-tina-bennet" title="Link target outside of Sample">Chapter 20: Tina Bennet</span></li>
<li id="toc-li-24"><span href="#/text/ch024#chapter-21-jean" title="Link target outside of Sample">Chapter 21: Jean</span></li>
<li id="toc-li-25"><span href="#/text/ch025#chapter-22-anthony-keith-and-troy" title="Link target outside of Sample">Chapter 22: Anthony, Keith and
                Troy</span></li>
<li id="toc-li-26"><span href="#/text/ch026#chapter-23-miriam" title="Link target outside of Sample">Chapter 23: Miriam</span></li>
<li id="toc-li-27"><span href="#/text/ch027#chapter-24-river-stanos" title="Link target outside of Sample">Chapter 24: River Stanos</span></li>
<li id="toc-li-28"><span href="#/text/ch028#chapter-25-ricky-paterson" title="Link target outside of Sample">Chapter 25: Ricky Paterson</span></li>
<li id="toc-li-29"><span href="#/text/ch029#chapter-26-barry-bennet" title="Link target outside of Sample">Chapter 26: Barry Bennet</span></li>
<li id="toc-li-30"><span href="#/text/ch030#chapter-27-the-gentlemens-club" title="Link target outside of Sample">Chapter 27: The Gentlemen’s Club</span>
</li>
<li id="toc-li-31"><span href="#/text/ch031#chapter-28-angela-bennet" title="Link target outside of Sample">Chapter 28: Angela Bennet</span></li>
<li id="toc-li-32"><span href="#/text/ch032#chapter-29-detective-james-jones" title="Link target outside of Sample">Chapter 29: Detective James
                Jones</span></li>
<li id="toc-li-33"><span href="#/text/ch033#chapter-30-the-harringtons" title="Link target outside of Sample">Chapter 30: The Harringtons</span></li>
<li id="toc-li-34"><span href="#/text/ch034#chapter-31-the-wedding" title="Link target outside of Sample">Chapter 31: The Wedding</span></li>
<li id="toc-li-35"><span href="#/text/ch035#chapter-32-rodney-harrington" title="Link target outside of Sample">Chapter 32: Rodney Harrington</span></li>
<li id="toc-li-36"><span href="#/text/ch036#chapter-33-detective-inspector-james-jones" title="Link target outside of Sample">Chapter 33: Detective
                Inspector James Jones</span></li>
<li id="toc-li-37"><span href="#/text/ch037#chapter-34-barnaby-brown" title="Link target outside of Sample">Chapter 34: Barnaby Brown</span></li>
<li id="toc-li-38"><span href="#/text/ch038#chapter-35-maureen-brown" title="Link target outside of Sample">Chapter 35: Maureen Brown</span></li>
<li id="toc-li-39"><span href="#/text/ch039#chapter-36-keith-and-janet-sullivan" title="Link target outside of Sample">Chapter 36: Keith and Janet
                Sullivan</span></li>
<li id="toc-li-40"><span href="#/text/ch040#chapter-37-anthony-and-angela-bennet" title="Link target outside of Sample">Chapter 37: Anthony and Angela
                Bennet</span></li>
<li id="toc-li-41"><span href="#/text/ch041#chapter-38-elaine" title="Link target outside of Sample">Chapter 38: Elaine</span></li>
<li id="toc-li-42"><span href="#/text/ch042#chapter-39-janet-sullivan" title="Link target outside of Sample">Chapter 39: Janet Sullivan</span></li>
<li id="toc-li-43"><span href="#/text/ch043#chapter-40-detective-inspector-james-jones" title="Link target outside of Sample">Chapter 40: Detective
                Inspector James Jones</span></li>
<li id="toc-li-44"><span href="#/text/ch044#chapter-41-old-joe" title="Link target outside of Sample">Chapter 41: Old Joe</span></li>
<li id="toc-li-45"><span href="#/text/ch045#chapter-42-the-school-bus" title="Link target outside of Sample">Chapter 42: The School Bus</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?079024ca